export const apiUrl = process.env.REACT_APP_BACKEND;
